import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IModule } from '@obvious.tech/constellation'

export const Module = defineEntity('Module', {
  endpoint: 'flow/api/Module',
  schema: SNoop<IModule>(),
})
